module.exports = __webpack_public_path__ + "img/ods-logo-header.f0c59e32.png";